import React from 'react';

const HalfCircleBlue = () => {
    return (
        <div>
                <div class="header__half-circle"></div>
        </div>
    );
};

export default HalfCircleBlue;